<div class="rectangleDiv">
  <!-- <img src="assets/images/rectangle.svg" alt="rectangle" /> -->
  <div class="txtContent">
    <div>
      <h1>We are 100% Independent and 100% Impartial</h1>
      <p>
        We are dedicated to finding our customers the very best deal on their gas and electric suppliers, as well as
        offering other top money-saving opportunities.
      </p>
    </div>
  </div>
</div>